import React from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const fmt = (v) => '$' + (v || 0).toLocaleString('en-US', { minimumFractionDigits: 0 })

const MarginSlider = ({ target, actual, totalCost, totalSell, onChange }) => {
  const delta = (totalSell || 0) - (totalCost || 0)
  const isDanger = (actual || 0) < 10

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '4px 0'
    }}>
      <input
        type="range"
        min={0}
        max={50}
        step={1}
        value={target || 0}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{
          width: 140,
          accentColor: isDanger ? tokens.danger : tokens.primary,
          cursor: 'pointer'
        }}
      />
      <span style={{
        fontFamily: tokens.fontMono,
        fontSize: 12,
        fontWeight: 600,
        color: isDanger ? tokens.danger : tokens.ink,
        whiteSpace: 'nowrap'
      }}>
        {Math.round(actual || 0)}% margin
      </span>
      <span style={{
        fontFamily: tokens.fontMono,
        fontSize: 11,
        color: isDanger ? tokens.danger : tokens.ink3,
        whiteSpace: 'nowrap'
      }}>
        {delta >= 0 ? '+' : ''}{fmt(delta)} vs cost
      </span>
    </div>
  )
}

export default MarginSlider
